// extracted by mini-css-extract-plugin
export default {"accordionHeader":"EventTitle_accordionHeader--mDO","sportName":"EventTitle_sportName--O9R","sportTitle":"EventTitle_sportTitle--aN6","flag":"EventTitle_flag--t0D"};